/**
 * API Phiên họp / Phiên tòa – POC dùng mock; triển khai thật dùng cùng endpoint với backend.
 */
import { apiSlice } from './apiSlice'
import type { CourtSession, CourtSessionCreate } from '../../types/session'

interface GetSessionsParams {
  case_id?: string
  from?: string
  to?: string
}

export const courtSessionsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSessions: builder.query<CourtSession[], GetSessionsParams | void>({
      query: (params) => {
        const search = new URLSearchParams()
        if (params?.case_id) search.set('case_id', params.case_id)
        if (params?.from) search.set('from', params.from)
        if (params?.to) search.set('to', params.to)
        const q = search.toString()
        return { url: q ? `court-sessions?${q}` : 'court-sessions', method: 'GET' }
      },
      providesTags: (result) =>
        result ? [...result.map(({ id }) => ({ type: 'CourtSessions' as const, id })), 'CourtSessions'] : ['CourtSessions'],
    }),
    createSession: builder.mutation<CourtSession, CourtSessionCreate>({
      query: (body) => ({ url: 'court-sessions', method: 'POST', body }),
      invalidatesTags: ['CourtSessions'],
    }),
  }),
})

export const { useGetSessionsQuery, useCreateSessionMutation } = courtSessionsApi
